/**************************************************
 * Nombre:       Formulario_Producto_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CategoryOutlined, EmojiFoodBeverageOutlined, Flag, Google} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSPRODUCTO} from "../../Constantes";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Producto_Pedido = ({...props}) => {
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        obtenerCol('categorias').then(dox => {
            setCategorias(dox.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={CategoryOutlined} nombre={'Categoria'} dato={'categoria'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={categorias.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EmojiFoodBeverageOutlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoDinero Icono={Google} nombre={'Valor'} dato={'valor'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Pedido